import { ThunkAction } from 'redux-thunk';
import {
    storeSelectedFiltersSuccess
} from '../../actions/load-cases';
import { ISelectedFilters } from '@telstra-connect/channel-care/state/cases';
import { IChannelCareState, IChannelCareAppState } from '@telstra-connect/channel-care/state/index';

/**
 * This thunk action updates the selected filters in the Redux store with new filter data.
 * It merges the existing selected filters with the new data provided and dispatches the updated filters.
 *
 * @param data - An object containing the new filter values to be applied.
 */
export function updateSelectedFilters(data: ISelectedFilters): ThunkAction<void, IChannelCareAppState, void> {
    return (dispatch, getState) => {
        const channelCareState: IChannelCareState = getState()?.channelCare;
        const filterData: ISelectedFilters = {
            ...channelCareState.selectedFilters,
            ...data
        }
        dispatch(storeSelectedFiltersSuccess(filterData))
    }
}

/**
 * This thunk action updates only the search text in the selected filters within the Redux store.
 * It replaces the existing search text while keeping other selected filters intact.
 *
 * @param searchText - The new search text to be applied to the selected filters.
 *
 * @Behavior
 * - It retrieves the current state of selected filters from the Redux store.
 * - The new search text is set while preserving other existing filter values.
 * - The updated filters are dispatched to the store using `storeSelectedFiltersSuccess`.
 */
export function updateSelectedText(searchText: string): ThunkAction<void, IChannelCareAppState, void> {
    return (dispatch, getState) => {
        const channelCareState: IChannelCareState = getState()?.channelCare;
        const filterData: ISelectedFilters = {
            ...channelCareState.selectedFilters,
            searchText,
        }
        dispatch(storeSelectedFiltersSuccess(filterData))
    }
}
